import Vue from "vue";

const GlobalStore = Vue.observable({
  commonInfo: {},
  loading: false,
});

export default GlobalStore;
